import { render, staticRenderFns } from "./HouseConsumption.vue?vue&type=template&id=f5f4135c&scoped=true&"
import script from "./HouseConsumption.vue?vue&type=script&lang=ts&"
export * from "./HouseConsumption.vue?vue&type=script&lang=ts&"
import style0 from "./HouseConsumption.vue?vue&type=style&index=0&id=f5f4135c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f4135c",
  null
  
)

export default component.exports